import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Slider from '../misc/Slider'
import './ContinueInBrowser.scss'
import '../misc/DarkAndLightModeSettings.scss'
import {acceptEidIdentTerms, createEidAttempt, createEidIdent} from '../../lib/emmiApi'
import Text from "../i18n/Text";
import I18nContext from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export default class ContinueInBrowser extends Component {

    static contextType = I18nContext

    state = {
        hasError: false,
        errorMessage: undefined
    }

    createAttempt = (event) => {
        event.stopPropagation()
        const caseId = this.props.caseId
        createEidIdent(caseId).then(_ => {
            return acceptEidIdentTerms(caseId).then(_ => {
                return createEidAttempt(caseId).then(response => {
                    const attemptId = response.attemptId
                    window.location.href =
                        `http://127.0.0.1:24727/eID-Client?tcTokenURL=https://` +
                        this.props.tcTokenUrlHost +
                        `/identportalEID/SamlRequest.html?parameter=${caseId}%26attemptId=${attemptId}`;
                })
            });
        }).catch(reason => {
            this.setState(() => ({hasError: true, errorMessage: reason}))
        })
    }

    postLinkHtml = getI18nTextWithContext(this.context, 'startEId.browser.postLink');

    render() {
        if (this.state.hasError) {
            throw new Error(this.state.errorMessage)
        }

        if(this.props.isMobileDevice || this.props.signingWorkFlow || this.props.v1bWorkflow) {
            return null
        } else {

            return <Slider duration={100}>
                <div className="container">
                    <div className="row">
                        <div className="p-0 text-small mb-5 continue-in-browser" data-test-id="05880657-0c78">
                            <Text k="startEId.browser.preLink"/>
                            <button type="button"
                                    className="link-button link" data-test-id="a2b760a8-935a"
                                    onClick={this.createAttempt}>
                                <Text k="startEId.browser.link"/>
                            </button>
                            <span id="externalLink-AusweisApp"
                                  dangerouslySetInnerHTML={{__html: this.postLinkHtml}}/>
                        </div>
                    </div>
                </div>
            </Slider>
        }
    }
}

ContinueInBrowser.propTypes = {
    caseId: PropTypes.string.isRequired,
    signingWorkFlow: PropTypes.bool,
    v1bWorkflow: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
    tcTokenUrlHost: PropTypes.string.isRequired
}
